
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/Textarea.html",
      function () {
        return require("private-next-pages/Forms/Textarea.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/Textarea.html"])
      });
    }
  